<template>
    <div class="approveModal">
        <dsh-modal
            v-model="showModal"
            :class='[
                "approveModal-modal",
                `approveModal-modal-${layout}`
            ]'
            :propsObj="selfModalPropsObj"
            :mode="selfModalPropsObj.mode"
        >
            <div class="approveModal-header" slot="header">
                <!-- 标题 -->
                <div class="header-name">
                    {{ selfModalPropsObj.title }}
                </div>

                <!-- 展示类别 -->
                <div class="header-groups">
                    <sheet-groups
                        :mode="layout"
                        :groups="groups"
                        @select="curComponentName = $event._key"
                    ></sheet-groups>
                </div>
            </div>

            <div class="approveModal-content">
                <component
                    v-if="showComponent"
                    ref="content"
                    :is="curComponentName"
                    :companyId="companyId"
                    :appId="appId"
                    :appObj="appObj"
                    :approveData="approveData"
                    :propsObj="propsObj"
                    @changeSign="changeSign"
                    @refresh="refreshCb"
                    @close="closeCb"
                ></component>
            </div>
        </dsh-modal>
    </div>
</template>

<script>
    import sheetGroups from "@/views/menu/sheet/attach/sheetGroups.vue";
    import approveOpinions from "./approveOpinions.vue";
    import approveChart from "./approveChart.vue";
    import approveLogs from "./approveLogs.vue";

    export default {
        name: "approveModal",
        mixins: [],
        components: {
            sheetGroups,
            approveContent: () => import("./approveContent/approveContent.vue"),
            approveOpinions,
            approveChart,
            approveLogs
        },
        props: {
            value: Boolean,

            companyId: {
                type: String,
                required: true
            },
            appId: {
                type: String,
                required: true
            },
            appObj: {
                type: Object,
                default () {
                    return {};
                }
            },

            approveData: {
                type: Object,
                default () {
                    return {
                        _id: undefined, // 任务的_id
                        step_inst: undefined,
                        flow_inst: {},
                        step_operate: undefined,
                        step_def: {},
                        flow: {},
                        mod: {},
                        data: {},
                        subFlowDef: {}
                    };
                }
            },
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
                curComponentName: "",

                showComponent: false,
                sign: false,
                refreshEventType: undefined
            };
        },
        computed: {
            showModal: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.closeCb(val);
                }
            },
            groups () {
                const groups = [
                    // { name: this.canEdit ? "处理任务" : "查看数据", _key: "approveContent" },
                    { name: "处理任务", _key: "approveContent" },
                    { name: "审批意见", _key: "approveOpinions" },
                    { name: "流程进度", _key: "approveChart" },
                    { name: "操作日志", _key: "approveLogs" }
                ];

                return this.taskId
                    ? groups
                    : groups.filter(item => ["approveContent"].includes(item._key));
            },

            taskId () {
                return this.approveData._id;
            },
            stepDefData () {
                return this.approveData.step_def || {};
            },
            flowData () {
                return this.approveData.flow || {};
            },
            formData () {
                return this.approveData.data || {};
            },

            taskClass () {
                return this.stepDefData.task_class;
            },
            flowDefKey () {
                return this.flowData.flowDef;
            },
            flowName () {
                return this.flowData.flowName;
            },
            dataId () {
                return this.formData._id;
            },

            layout () {
                return this.appObj.layout || "tradition";
            },
            selfModalPropsObj () {
                return {
                    mode: "large",
                    title: this.flowName
                };
            }
        },
        created () {
            this.init();
        },
        methods: {
            // 初始化
            init () {
                this.initMonitor();

                this.curComponentName = this.groups[0] && this.groups[0]._key;
                this.taskId ? this.getApproveObj() : this.getDefaultApproveObj();
            },
            // 初始化监测数据
            initMonitor () {
                ["_id", "step_inst", "flow_inst", "step_operate", "step_def", "flow", "mod", "data", "subFlowDef"].forEach(key => {
                    this.$set(this.approveData, key, this.approveData[key]);
                });
            },

            // change状态变动
            changeSign (sign = true) {
                this.sign = sign;
            },
            // 刷新
            refreshCb (eventType) {
                this.refreshEventType = eventType;
            },
            // 关闭模态框
            closeCb (bool) {
                const closeFuc = () => {
                    this.refreshEventType && this.$emit("refresh", this.refreshEventType);
                    this.$emit("input", false);
                };

                if (!bool) {
                    if (this.sign) {
                        this.$Modal.confirm({
                            title: "改动提示",
                            content: "您需要保存刚才的改动吗？",
                            // content: `您需要保存刚才的改动吗？${this.$refs.content.taskId ? "" : "保存后会发起该流程"}`,
                            okText: "保存",
                            cancelText: "不保存",
                            onOk: () => {
                                this.$refs.content.save(() => {
                                    closeFuc();
                                });
                            },
                            onCancel: () => {
                                closeFuc();
                            }
                        });
                    } else {
                        closeFuc();
                    }
                }
            },

            /* --------- 接口和工具方法 --------- */
            // 接口 -获取审批的各种数据
            getApproveObj () {
                this.showComponent = false;
                this.$https({
                    url: {
                        module: "approve",
                        name: "show"
                    },
                    params: {
                        task: this.taskId,
                        task_class: this.taskClass === "notify" ? this.taskClass : undefined // 传此参数原因：后端判断是知会还是流程编辑的任务，后端两张表
                    },
                    callback: data => {
                        this.showComponent = true;
                        Object.assign(this.approveData, {
                            ...data,
                            mod: this.transformMod(data)
                        });
                    }
                });
            },
            // 接口 -获取默认审批的各种数据
            getDefaultApproveObj () {
                this.showComponent = false;
                return this.$https({
                    url: {
                        module: "approve",
                        name: "startFlow"
                    },
                    params: {
                        flowDefKey: this.flowDefKey,
                        dataId: this.dataId
                    },
                    callback: data => {
                        this.showComponent = true;
                        Object.assign(this.approveData, {
                            step_operate: "waiting",
                            ...data,
                            mod: this.transformMod(data),
                            data: {
                                ...data.data,
                                ...this.approveData.data // 自定义页多条关联字段的发起的流程，会传_filterField绑定的值
                            }
                        });
                    }
                });
            },
            // 后端给的mod，form字段是完整的，screens里的form不是配置内容，前端自己加工，目的和工作表那边保持一致，可以使用modSchemaMixin
            transformMod (data) {
                return {
                    ...data.mod,
                    screens: data.mod.screens.map(screenItem => {
                        return {
                            ...screenItem,
                            form: data.mod.form.slice()
                        };
                    })
                };
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/flow/approve/approveModal/index.vue